import type { AccountRequest } from '@/types/api/events/allocation-update'

export function getUniqueCustodianIdsFromAccountRequests(
  accountRequests: AccountRequest[],
): string[] {
  const custodianIds = new Set<string>()
  for (const req of accountRequests) {
    const custodianId = req.account_configuration?.custodian_id
    if (custodianId) {
      custodianIds.add(custodianId)
    }
  }
  return Array.from(custodianIds)
}
